import DeclineModal from '@containers/decline-modal';
import { ClientTrackingCategory } from '@models/client-tracking-category';
import FormI9EmployeeInformation from '@screens/review-section2/employee-information/page';
import {
    createDeclineModalStore,
    createOnboardingDetailsRequestService,
    createSection1CandidateDetailsStore,
    createSection1PreparerTranslatorStore,
    createSection2DocumentsStore,
    createSection2ReviewStore,
    createTrackingService,
    createTranslationService
} from '@services/factories';
import { IOnboardingDetailsRequestService } from '@services/onboarding-review/onboarding-details-request-service';
import { ITrackingService } from '@services/TrackingService';
import { IDeclineModalStore } from '@stores/modal/decline-modal-store';
import { ISection1CandidateDetailStore } from '@stores/onboarding-review/section1-candidate-detail-store';
import { ISection1PreparerTranslatorStore } from '@stores/onboarding-review/section1-preparer-translator-store';
import { ISection2ReviewStore } from '@stores/onboarding-review/section2-review-store';
import { cacheTranslations } from '@utils/cache-translations';
import { observer } from 'mobx-react';
import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import {
    merge,
    Subscription
} from 'rxjs';
import {
    continueOnboardingReview,
    finishOnboardingReview,
    FlowAction,
    onboardingFlowActions
} from '@flows/onboarding-review/navigation';
import { ISection2DocumentsStore } from '@stores/onboarding-review/section2-documents-store';

enum GlobalTranslation {
    declineSection2Context = 'declineSection2Context'
}

@observer
class I9EmployeeInformationReview extends React.Component<RouteComponentProps> {
    // Probably good idea to dependency inject these later
    store: ISection2ReviewStore = createSection2ReviewStore();
    candidateDetailsStore: ISection1CandidateDetailStore = createSection1CandidateDetailsStore();
    preparerTranslatorStore: ISection1PreparerTranslatorStore = createSection1PreparerTranslatorStore();
    trackingService: ITrackingService = createTrackingService();
    onboardingDetailsRequestService: IOnboardingDetailsRequestService = createOnboardingDetailsRequestService();
    declineModalStore: IDeclineModalStore = createDeclineModalStore();
    documentsStore: ISection2DocumentsStore = createSection2DocumentsStore();

    private requestEventSubscription: Subscription = Subscription.EMPTY;
    private onboardingFlowRouteSubscription: Subscription = Subscription.EMPTY;

    readonly globalTranslations = cacheTranslations(
        createTranslationService(),
        GlobalTranslation
    );

    async componentDidMount() {
        this.onboardingFlowRouteSubscription = merge(
            continueOnboardingReview,
            finishOnboardingReview
        ).subscribe(
            route => this.props.history.push(route),
            error => {
                console.error(error);
                // todo: display error feedback
            }
        );

        // side effect of requesting details, must client track it
        this.requestEventSubscription = this.onboardingDetailsRequestService
            .requestEvents
            .subscribe(
            event => {
                // temporary until a better place is designed
                this.store.setLoadDetailsRequestStatus(event.type);

                if (event.type === 'success') {
                    // todo: client track load success
                    return;
                }

                if (event.type === 'error') {
                    // todo: client track load error
                    console.error(event.error);
                    return;
                }
            }
        );
        await this.onboardingDetailsRequestService.triggerRequest();
    }

    componentWillUnmount() {
        this.requestEventSubscription.unsubscribe();
        this.onboardingFlowRouteSubscription.unsubscribe();
    }

    handleConfirm = () => onboardingFlowActions.next(FlowAction.ConfirmEmployeeInfo);

    showDeclineModal = () => this.declineModalStore.openModal();

    handleDeclineSuccess = () => onboardingFlowActions.next(FlowAction.Decline);

    render() {
        return (
            <React.Fragment>
                <FormI9EmployeeInformation reviewStore={this.store}
                                           preparerTranslator={this.preparerTranslatorStore}
                                           candidateDetails={this.candidateDetailsStore}
                                           documentDetails={this.documentsStore}
                                           onDecline={this.showDeclineModal}
                                           onConfirm={this.handleConfirm} />
                <DeclineModal store={this.declineModalStore}
                              onDeclineSuccess={this.handleDeclineSuccess}
                              trackingCategory={ClientTrackingCategory.Section2Decline}
                              declineQuestionContext={this.globalTranslations.declineSection2Context} />
            </React.Fragment>
        );
    }
}

export default I9EmployeeInformationReview;



// WEBPACK FOOTER //
// ./src/screens/review-section2/employee-information/index.tsx